import React from 'react';
import PropTypes from 'prop-types';
import { Trigger } from 'chaperone';
import Tooltip from 'Snippets/Tooltip';
import Toast from 'Snippets/Toast';
import { clipBoard, is } from 'Common/Utils';
import { Tab } from '../';
import './index.css';

const CodePanelProps = {
	triggerId: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.object,
	]),
	originalId: PropTypes.string,
	triggerIndex: PropTypes.number,
	menu: PropTypes.oneOfType([
		PropTypes.element,
		PropTypes.arrayOf(PropTypes.element),
	]),
	children: PropTypes.oneOfType([
		PropTypes.element,
		PropTypes.arrayOf(PropTypes.element),
	]),
};

const CodePanelDefaults = {
	triggerIndex: 0,
};

export const CodePanel = ({
	triggerId,
	triggerIndex,
	originalId,
	menu,
	children,
}) => { 
	const handleClick = (e) => {
		const target = e.target
			.closest('.codesnippet')
			.querySelector(
				is.obj(triggerId) ? '.tab-panel.active pre' : '.code pre'
			);

		clipBoard(target.innerText);
		Toast.create(
			<>
				<i className='mytabworks icon-copy'></i> Copied!{' '}
			</>
		);
	};
	return (
		<div className='codesnippet n-flat br-1r'>
			<div className='header'>
				<div className='control success'></div>
				<div className='control warning'></div>
				<div className='control danger'></div>
				<div className='clear'></div>
				{menu}
			</div>
			<div className='menu-bar'>
				<nav>
					<Tooltip message='copy' variant='dark'>
						<span onClick={handleClick}>
							<i className='mytabworks icon-copy' />
						</span>
					</Tooltip>
				</nav>
				{triggerId &&
					(is.obj(triggerId) ? (
						<>
							<nav className='nav-tabs'>
								{Object.keys(triggerId).map((id) => (
									<Tab.Link className='nav-link' eventKey={triggerId[id]} key={id}>
										{id}
									</Tab.Link>
								)) }
							</nav>
							{originalId && (
								<Tab.Content>
									{Object.keys(triggerId).map((id) => (
										<Tab.Pane eventKey={triggerId[id]} key={id}>
											<Tooltip message='help' placement='right' variant='dark'>
												<Trigger
													id={`${originalId}-${id}`}
													index={triggerIndex}
													allowTransition
													label={
														<i className='mytabworks icon-question-mark' />
													}
												/>
											</Tooltip>
										</Tab.Pane>
									))}
								</Tab.Content>
							)}
						</>
					) : (
						<nav>
							<Tooltip message='help' placement='right' variant='dark'>
								<Trigger
									id={triggerId}
									index={triggerIndex}
									allowTransition
									label={<i className='mytabworks icon-question-mark' />}
								/>
							</Tooltip>
						</nav>
					))}
			</div>
			<div className='code-content'>{children}</div>
		</div>
	);
};

CodePanel.propTypes = CodePanelProps;
CodePanel.defaultProps = CodePanelDefaults;
